export enum BandedRowColorContrast {
  Darken = 'DARKEN',
  Lighten = 'LIGHTEN'
}
